module.exports = __webpack_public_path__ + "static/task-template-cards-68d424b14e2f13c8921244e83605cdf9.svg";